export const isProd = import.meta.env.MODE === 'production'
export const isDev = !isProd
const adminUrl = import.meta.env.VITE_MODII_ADMIN_API
const environment =  import.meta.env.VITE_MODII_ADMIN_ENVIRONMENT

let config = {
    apiUrl: 'https://data-collection-api.spotparking.com.au',
    adminUrl,
    environment
}

const overrideApi = import.meta.env.VITE_API_OVERRIDE

// switch (process.env.REACT_APP_API_OVERRIDE) {
switch (overrideApi) {
    case 'demo':
        config.apiUrl = 'https://data-collection-api-demo.spotparking.com.au'
        break

    case 'demo-usa':
        config.apiUrl = 'https://data-collection-api-demo-usa.spotparking.com.au'
        break

    default:
        break
}

export default config
